import { isNotEqual } from './common/compare';
import { fieldArgumentDescriptionChanged, fieldArgumentDefaultChanged, fieldArgumentTypeChanged, } from './changes/argument';
import { diffArrays } from '../utils/arrays';
export function changesInArgument(type, field, oldArg, newArg) {
    const changes = [];
    if (isNotEqual(oldArg.description, newArg.description)) {
        changes.push(fieldArgumentDescriptionChanged(type, field, oldArg, newArg));
    }
    if (isNotEqual(oldArg.defaultValue, newArg.defaultValue)) {
        if (Array.isArray(oldArg.defaultValue) &&
            Array.isArray(newArg.defaultValue)) {
            const diff = diffArrays(oldArg.defaultValue, newArg.defaultValue);
            if (diff.length > 0) {
                changes.push(fieldArgumentDefaultChanged(type, field, oldArg, newArg));
            }
        }
        else if (JSON.stringify(oldArg.defaultValue) !==
            JSON.stringify(newArg.defaultValue)) {
            changes.push(fieldArgumentDefaultChanged(type, field, oldArg, newArg));
        }
    }
    if (isNotEqual(oldArg.type.toString(), newArg.type.toString())) {
        changes.push(fieldArgumentTypeChanged(type, field, oldArg, newArg));
    }
    return changes;
}
//# sourceMappingURL=argument.js.map